import { useContext, useState, useEffect, useCallback, useMemo } from 'react';
import { useLoaderData, useNavigate } from 'react-router-dom';
import { AuthContext } from '../../context/AuthContext';
import PaginatedCards from '../paginatedCards/PaginatedCards';
import apiRequest from '../../lib/apiRequest';
import './recommended.scss';

const RecommendedAds = () => {
  const post = useLoaderData();
  const { currentUser } = useContext(AuthContext);
  const [relatedPosts, setRelatedPosts] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchRelatedPosts = async () => {
      try {
        const response = await apiRequest.get(
          `/posts?category=${post.category}&subcategory=${post.subcategory}&country=${post.country}`
        );
        setRelatedPosts(response.data);
      } catch (err) {
        console.log(err);
      }
    };
    if (post.category && post.subcategory) {
      fetchRelatedPosts();
    }
  }, [post.category, post.subcategory, post.country]);

  const handlePostClick = useCallback(
    (url) => {
      setTimeout(() => {
        navigate(url);
      }, 2200);
    },
    [navigate]
  );

  return (
    <div className="relatedPosts">
      <h2>You may also like</h2>
      {relatedPosts.length > 0 ? (
        <PaginatedCards
          posts={relatedPosts}
          onPostClick={handlePostClick}
          currentUserId={currentUser ? currentUser.id : null}
        />
      ) : (
        <p>No recommended ads available.</p>
      )}
    </div>
  );
};

export default RecommendedAds;
